<template>
    <div id="app">
        <!-- <zf-loading v-show="loading"></zf-loading> -->
        <el-container class="router-page">
            <el-main>
                <router-view v-if="show" :key="$route.fullPath"/>
            </el-main>
        </el-container>
    </div>
</template>

<script>
  import Loading from "@/components/common/loading";
  import {Component, Vue, Watch} from "vue-property-decorator";

  @Component({
    components: {
      'zf-loading': Loading,
    },
  })
  export default class App extends Vue {

    created(){
    }

    get show() {
      return this.$store.state.show;
    }

    get loading() {
      return this.$store.state.loading;
    }

  }
</script>

<style lang="scss">
    @import "src/scss/theme-variables";

    * {
        box-sizing: border-box;
        font-family:'PingFang SC','Microsoft YaHei','Avenir','Tahoma','Arial', sans-serif;
    }

    #app {
        min-width: 1280px;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    html,body {
        -webkit-text-size-adjust: 100%;
        -webkit-font-smoothing: antialiased;
    }

    body,
    dd,
    dl,
    dt,
    fieldset,
    form,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    html,
    img,
    legend,
    li,
    ol,
    p,
    ul,
    input,
    select,
    textarea {
        margin: 0;
        padding: 0;
        -webkit-tap-highlight-color: transparent;
    }

    h1 {
        font-size: 22px;
        font-weight: bold;
    }

    h2 {
        font-size: 18px;
    }

    button,
    fieldset,
    img,
    input {
        border: none;
        padding: 0;
        margin: 0;
        outline-style: none;
    }

    ul,
    li {
        background-color: #ffffff;
    }

    ol,
    ul {
        list-style: none;
    }

    input {
        padding-top: 0;
        padding-bottom: 0;
    }

    input,
    select {
        vertical-align: middle;
    }

    textarea {
        resize: none;
    }

    /*防止拖动*/
    img {
        border: 0;
        vertical-align: middle;
    }

    /*  去掉图片低测默认的3像素空白缝隙*/
    table {
        border-collapse: collapse;
    }

    i {
        font-style: normal;
    }

    a {
        color: #666;
        text-decoration: none;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none !important;
        margin: 0;
    }

    .router-page {
        display: flex;
        /*height: calc(100vh - 60px);*/
        /*border: 1px solid #eee;*/
    }

    .el-main {
        position: relative;
        width: 100%;
        height: 100%;
        padding: 0 !important;
        background: #F4F5F9;
    }

    body .el-table th.gutter {
        display: table-cell !important;
    }

    body .el-table colgroup.gutter {
        display: table-cell !important;
    }

    table {
        width: 100% !important;
    }

    .yc-wrap {
        display: flex;
        height: calc(100% - 60px);
        width: 100%;

        .yc-aside {
            flex: 0 0 auto;
        }

        .content {
            width: 100%;
            padding: 12px 16px;
            overflow: scroll;
        }
    }

    .yc-content {
        display: flex;
        overflow: hidden;
        background: #FFFFFF;
        margin: 24px 32px;
        height: calc(100% - 108px);
        border-radius: 2px;
        box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.04);

        .main-tab {
            width: 100%;
            height: 100%
        }

        .main-tab.el-tabs--card > .el-tabs__header {
            margin: 0;
            background: #FAFAFC;
        }

        .main-tab.el-tabs--card > .el-tabs__header .el-tabs__nav {
            display: flex;
            width: 100%;
            height: 60px;
            text-align: center;
            border: none;
        }

        .main-tab.el-tabs--card > .el-tabs__header .el-tabs__item {
            padding: 18px 16px;
            min-width: 140px;
            height: 60px;
            background: #FAFAFC;
            line-height: 25px;
            border-color: rgba(216, 216, 216, .37);
            color: mix(#535875, #FFFFFF, 70%);
            font-size: 16px;
            font-weight: 400;
        }

        .main-tab.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
            color: $--color-ultramarine-blue;
            border-color: #E4E7ED;
            background: #FFFFFF;
            border-bottom: none;
            font-weight: 600;
        }

        .main-tab.el-tabs--card > .el-tabs__header .el-tabs__item:last-child.is-active {
          border-right: 1px solid #E4E7ED;
        }

        .main-tab.el-tabs--card > .el-tabs__content {
            height: calc(100% - 60px);
        }

        .main-tab.el-tabs--card > .el-tabs__content .el-tab-pane {
            height: 100%;
        }

        .yc-content-inner {
            width: 100%;
            padding: 40px 36px 0 66px;
            overflow: scroll;
            color: #535875;


            h1 {
                margin-bottom: 8px;
                line-height: 45px;
                font-size: 32px;
                font-weight: 600;
                color: #0F1222;
            }

            p {
                line-height: 22px;
                font-size: 14px;
            }
        }
    }

    #app .yc-table::before {
        height: 0;
    }

    #app .yc-table {
        height: calc(100% - 88px);

        .el-table__body-wrapper {
            height: calc(100% - 38px);
            overflow-y: scroll;
        }

        .el-table__row {
            border: none;
        }

        td,
        th {
            .cell {
                line-height: 22px;
                font-weight: 400;
                color: #21202A;
            }
        }

        td {
            padding: 16px 0;
            border-bottom: 1px solid #F5F5F7;
            background: #ffffff;
        }

        tr.el-table__row--striped td {
            background: #ffffff;
        }

        th {
            height: 40px;
            padding: 8px 0;
            border: none;
            background-color: #F5F5F7;
        }

        th > .cell {
            height: 22px;
            padding: 0 10px!important;
            color: #7C7B85;
            font-weight: 500;

            .caret-wrapper{
                position: relative;
                top: -4px;
                vertical-align: top;
            }
        }

        .bold-column-rate{
            font-family: 'SF',sans-serif;
            height: 24px;
            font-size: 16px;
            font-weight: 500;
            color: #21202A;
            line-height: 24px;
        }
        .bold-column-num{
            height: 20px;
            font-size: 12px;
            font-weight: 400;
            color: #535875;
            line-height: 20px;
            opacity: .7;
        }

        td:first-child,
        th:first-child {
            border-radius: 4px 0 0 4px;
            padding-left: 6px;
        }

        td:last-child,
        th:last-child {
            border-radius: 0 4px 4px 0;
            padding-right: 6px;
        }

        .el-table__body {
            .bold-column > .cell {
                font-family: 'SF',sans-serif;
                height: 24px;
                line-height: 24px;
                font-size: 16px ;
                font-weight: 500;
                color: #21202A;
            }
        }
        .el-table__empty-block{
            width: 100% !important;
            transition: width 4s;
        }
        .el-table__empty-text {
            line-height: 60px;
            width: 100%;
            color: #909399;
            margin: 0 auto;
        }
}

    .el-table__body {
        // 使表格兼容safari，不错位
        width: 100%;
        table-layout: fixed !important;
    }

    /* 悬浮框样式 */
    .el-dialog__body {
        padding-top: 10px!important;
        padding-bottom: 20px!important;
    }

    /* 图片上传样式 */
    .el-upload {
        height: 100%;
    }
    .el-upload-list__item {
        transition: none !important;
    }
    .el-upload--picture-card {
        margin-bottom: 23px;
    }

    /* 表格样式 */

    .el-form--label-top {

        .el-form-item {
            margin-bottom: 24px;

            .el-form-item__label {
                padding: 0 0 7px 0;
                color: #0F1222;
                line-height: 32px;
                height: 32px;
            }

            .el-form-item__content {
                line-height: 32px;
            }

        }
    }

    .el-range-editor--small .el-range-separator {
        padding: 0!important;
        margin: 0 5px!important;
    }

    .icon {
        width: 1em;
        height: 1em;
        vertical-align: -0.15em;
        fill: currentColor;
        overflow: hidden;
    }
    .el-tabs__item {
        color: rgba(53,58,75,.7) !important;
        &.is-active {
            color: #513EFF !important;
        }
    }
    .el-tabs__active-bar {
        bottom: 8px !important;
    }
    .el-tabs__nav-wrap::after{
        background-color: rgba($color: #000000, $alpha: 0) !important;
    }

    .main {
        width: 100%;
        height: 100%;
        padding: 16px 24px 10px 26px ;
        position: relative;
        overflow: hidden;
        .main-contont{
            height: calc(100% - 46px);
            overflow-y: scroll;
        }
        .draw-footer {
            width: calc(100% - 50px);
            height: 46px;
            position: absolute;
            bottom: 0px;
            background: #F5F6FA;
            .footer-button-cancel{
            grid-area: 2/2/3/3;
            margin-right: 24px;
            float: right;

            }
        }
        .el-breadcrumb{
            font-size: 16px;
            color: #3E7EFF !important;
            .el-breadcrumb__item{
                &:last-child .el-breadcrumb__inner{
                    color: #3E7EFF !important;
                    font-weight: 600;
                }
                .el-breadcrumb__separator{
                    color: #3E7EFF !important;
                    font-weight: 600;
                }
            }
        }
    }

    #app .el-pagination {
        padding-right: 0;
    }

    #app .el-pagination__sizes {
        margin-right: -5px;
    }
    #app .el-pagination .el-pagination__total {
        color: #1D2029;
        font-size: 14px;
    }
    #app .el-pagination .el-select__caret {
        position: relative;
        top: -2px;
        left: -2px;
        font-size: 15px;
        color: #21202a;
    }
    #app .el-pagination__sizes .el-input__inner {
        font-size: 14px;
        color: #21202a;
        border-color: #c5c4ce;
    }
    #app .el-pagination .btn-prev, #app .el-pagination .btn-next, #app .el-pager li {
        color: #4e5969;
        font-size: 14px;
        position: relative;
        top: -1px;
        padding: 0 4px;
        margin: 0 4px;
        height: 32px;
        // width: 32px;
        min-width: 32px;
        line-height: 32px;
        .el-icon {
            font-size: 14px;
        }
    }

    #app .el-pagination button:disabled {
        color: #C0C4CC;
    }
    #app .el-pagination .btn-prev, #app .el-pagination .btn-next {
        border-color: rgba(0,0,0,.15);
    }
    #app .el-pager li {
        color: #4E5969;
        font-weight: 400;
    }
    #app .el-pager li.active {
        background: #513EFF;
        border-radius: 16px;
        color: #FFFFFF;
    }

    #app .el-pagination .btn-prev, #app .el-pagination .btn-next {
        border-radius: 4px;
        border: 1px solid #E4E3EB;
    }

    .el-tooltip__popper.is-dark {
        background: #FFF!important;
        color: #535875!important;
        box-shadow: 0 4px 10px #0000001a;
        .popper__arrow {
            border: none;
        }
        .popper__arrow::after {
            border: #FFF!important;
        }
    }



</style>
